export default __webpack_public_path__ + "static/media/logo.6db43b12.png";